import { Injectable } from '@angular/core';
import { NavItemInternal } from '../../../Common/Layout/components/Navbar/navbar.component';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserFeaturesService {
    private userFeaturesSubject = new BehaviorSubject<NavItemInternal[]>([]);
    userFeatures$ = this.userFeaturesSubject.asObservable();

    setUserFeatures(features: NavItemInternal[]) {
        this.userFeaturesSubject.next(features);
    }
}
